import EmptyRouterView from '../router/EmptyRouterView';
import RecruiterUserSetting from '../views/AdminBase/AdminBaseSettings';

import RecruiterDashboard from '../views/AdminBase/AdminBaseDashboard';
import RecruiterPipelines from '../views/AdminBase/AdminBasePipelines';
import RecruiterCandidates from '../views/AdminBase/AdminBaseCandidates';

import RecruiterJobs from '../views/AdminBase/AdminBaseJobs';

import RecruiterCandidateItem from '../components/Admin/Candidates/CandidateItem';
import RecruiterJobItem from '@/components/Admin/Jobs/JobItem';

import RecruiterEmployers from '../views/AdminBase/AdminBaseEmployers';
import RecruiterEmployersItem from '../components/Admin/Employers/EmployersItem';

import RecruiterBaseReviewJobs from '../views/AdminBase/AdminBaseReviewJobs';
import RecruiterBaseReviewApplications from '../views/AdminBase/AdminBaseReviewApplications';

const url_prefix = process.env.VUE_APP_URL_PREFIX;

export default [
  {
    path: '/recruiter',
    name: 'recruiter',
    redirect: url_prefix + '/recruiter/dashboard',
    meta: {
      requiresAuth: true,
      recruiterAuth: true,
    },
  },
  /* {
    path: url_prefix + '/recruiter/profile',
    name: 'recruiter-profile',
    component: EmployersProfileAdminView,
    meta: {
      requiresAuth: true,
      recruiterAuth: true,
    },
  }, */
  {
    path: '/recruiter/dashboard',
    name: 'recruiter-dashboard',
    component: RecruiterDashboard,
    meta: {
      requiresAuth: true,
      recruiterAuth: true,
      breadcrumb: 'Dashboard',
    },
  },
  {
    path: '/recruiter/pipelines',
    name: 'recruiter-pipelines',
    component: RecruiterPipelines,
    meta: {
      requiresAuth: true,
      recruiterAuth: true,

      breadcrumb: function() {
        //const { name } = this.$route;
        return 'Pipelines';
      },
    },
  },
  // recruiter/Candidates
  {
    path: '/recruiter',
    component: EmptyRouterView,
    meta: {
      requiresAuth: true,
      recruiterAuth: true,
    },
    children: [
      {
        path: '/recruiter/candidates',
        name: 'recruiter-candidates',
        component: RecruiterCandidates,
        meta: {
          requiresAuth: true,
          recruiterAuth: true,

          breadcrumb: 'Candidates',
        },
      },
      {
        path: '/recruiter/candidates',
        name: '',
        component: EmptyRouterView,
        meta: {
          requiresAuth: true,
          recruiterAuth: true,

          breadcrumb: '',
        },
        children: [
          {
            path: '/recruiter/candidates/:recruiter_candidate_id',
            name: 'recruiter_candidate_id',
            component: RecruiterCandidateItem,
            meta: {
              requiresAuth: true,
              recruiterAuth: true,

              breadcrumb: function() {
                return `${this.$store.getters.getCandidateById.first_name} ${this.$store.getters.getCandidateById.last_name}`;
              },
            },
          },
        ],
      },
    ],
  },
  // recruiter/Jobs
  {
    path: '/recruiter',
    component: EmptyRouterView,
    meta: {
      requiresAuth: true,
      adminAuth: true,
      recruiterAuth: true,
      managerAuth: true,
    },
    children: [
      {
        path: '/recruiter/jobs',
        name: 'recruiter-jobs',
        component: RecruiterJobs,

        meta: {
          requiresAuth: true,
          adminAuth: true,
          recruiterAuth: true,
          managerAuth: true,
          breadcrumb: 'Jobs',
        },
      },
      {
        path: '/recruiter/jobs',
        name: '',
        component: EmptyRouterView,
        meta: {
          requiresAuth: true,
          adminAuth: true,
          recruiterAuth: true,
          managerAuth: true,
          breadcrumb: '',
        },
        children: [
          {
            path: '/recruiter/jobs/:job_uuid',
            name: 'recruiter_job_uuid',
            component: RecruiterJobItem,
            meta: {
              requiresAuth: true,
              adminAuth: true,
              recruiterAuth: true,
              managerAuth: true,
              breadcrumb: function() {
                return '';
              },
            },
          },
        ],
      },
    ],
  },
  // recruiter/Employers
  {
    path: '/recruiter',
    component: EmptyRouterView,
    meta: {
      requiresAuth: true,
      recruiterAuth: true,
    },
    children: [
      {
        path: '/recruiter/employers',
        name: 'recruiter-employers',
        component: RecruiterEmployers,
        meta: {
          requiresAuth: true,
          recruiterAuth: true,

          breadcrumb: 'Employers',
        },
      },
      {
        path: '/recruiter/employers',
        name: '',
        component: EmptyRouterView,
        meta: {
          requiresAuth: true,
          recruiterAuth: true,
        },
        children: [
          {
            path: '/recruiter/employers/:recruiter_employer_id',
            name: 'recruiter_employer_id',
            component: RecruiterEmployersItem,
            meta: {
              requiresAuth: true,
              recruiterAuth: true,

              breadcrumb: function() {
                return this.$store.getters.getEmployerById.name;
              },
            },
          },
        ],
      },
    ],
  },
  {
    path: '/recruiter/settings',
    name: 'recruiter-settings',
    component: RecruiterUserSetting,
    meta: {
      requiresAuth: true,
      recruiterAuth: true,
    },
  },
  // Recruiter Review
  {
    path: '/recruiter/review/jobs',
    name: 'recruiter-review-jobs',
    component: RecruiterBaseReviewJobs,
    meta: {
      requiresAuth: true,
      recruiterAuth: true,

      breadcrumb: function() {
        return 'Review / Jobs';
      },
    },
  },
  {
    path: '/recruiter/review/applications',
    name: 'recruiter-review-applications',
    component: RecruiterBaseReviewApplications,
    meta: {
      requiresAuth: true,
      recruiterAuth: true,

      breadcrumb: function() {
        return 'Review / Applications';
      },
    },
  },
];
